





























    import {Vue, Component, Mixins, Prop, Watch} from 'vue-property-decorator';
	import Loader from '@/components/Common/Loader.vue';
    import BaseComponent from "@/plugins/BaseComponent";
    import { Controller} from "@/plugins/Controller";
    import {AxiosResponse} from "axios";

    import { Hooper, Slide, Pagination as HooperPagination, } from 'hooper';
    import {Endpoints} from "@/plugins/endpoints";

    @Component({
		components:{
		    Loader,
            Hooper,
			Slide,
            HooperPagination
        }
	})
	export default class SliderPage extends Mixins(BaseComponent) {
        @Prop()
		pageUrl: string;

        private controller: Controller = new Controller();
	    private items: any[] = [];

        mounted(){
            this.getItem();
		}

		getItem(){
            this.showLoader();
            this.controller.GetBanner().then(this.gotItem);
		}

		gotItem(response: AxiosResponse){
            this.items = [];
            this.items = response.data;
            this.hideLoader();
            this.pageUrlHandler();
		}

		getImageUrl(item: any): string{
            return Endpoints.File_Download(JSON.parse(item.value.Image).id);
		}

        @Watch('$route', { immediate: true, deep: true })
		pageUrlHandler(){
            if(this.$route.name == "PageViewer"){
                let index = this.items.findIndex(i => i.value.URL == this.$route.params.identifier);
                if(index != -1){
					(this.$refs.hooper as any).slideTo(index);
				}
                else{
					(this.$refs.hooper  as any).slideTo(0);
				}

			}

		}

	}
